(() => {
 const validate=(entry,width,height)=>{
  if(!entry||entry.verified!==true||entry.sourceWidth!==width||entry.sourceHeight!==height)throw Error('SOURCE_GEOMETRY_UNCONFIRMED');
  const crop=entry.crop||{x:0,y:0,width,height};
  if(!['x','y','width','height'].every(k=>Number.isInteger(crop[k]))||crop.x<0||crop.y<0||crop.width<1||crop.height<1||crop.x+crop.width>width||crop.y+crop.height>height||Math.abs(crop.width/crop.height-1.5)>.015)throw Error('SOURCE_CROP_INVALID');
  return crop;
 };
 const extendCorners=(pixels,width,height,radiusMm)=>{
  if(!Number.isFinite(radiusMm)||radiusMm<0||radiusMm>25)throw Error('SOURCE_RADIUS_INVALID');
  const rx=radiusMm*width/210,ry=radiusMm*height/140;
  if(!rx||!ry)return pixels;
  const original=pixels.slice();
  for(const right of [false,true])for(const bottom of [false,true]){
   const cx=right?width-rx:rx,cy=bottom?height-ry:ry;
   for(let v=0;v<Math.ceil(ry);v++)for(let u=0;u<Math.ceil(rx);u++){
    const x=right?width-1-u:u,y=bottom?height-1-v:v,dx=(x+.5-cx)/rx,dy=(y+.5-cy)/ry,d=Math.hypot(dx,dy);
    if(d<=1)continue;
    // Sample safely inside the original curve, only filling outside that curve.
    const k=.96/d,sx=Math.max(0,Math.min(width-1,Math.round(cx+dx*k*rx-.5))),sy=Math.max(0,Math.min(height-1,Math.round(cy+dy*k*ry-.5)));
    const to=(y*width+x)*4,from=(sy*width+sx)*4;for(let c=0;c<4;c++)pixels[to+c]=original[from+c];
   }
  }
  return pixels;
 };
 const prepare=(source,entry)=>{
  const crop=validate(entry,source.width,source.height),canvas=document.createElement('canvas');canvas.width=crop.width;canvas.height=crop.height;
  const context=canvas.getContext('2d',{willReadFrequently:true});context.drawImage(source,crop.x,crop.y,crop.width,crop.height,0,0,crop.width,crop.height);
  if(entry.sourceCornerRadiusMm>0){const image=context.getImageData(0,0,canvas.width,canvas.height);
   // Padded originals contain a one-pixel raster outline/antialias fringe.
   // Replace only that outside fringe; the original file and customer preview stay intact.
   if(crop.x>0&&crop.y>0){const data=image.data,copy=data.slice(),w=canvas.width,h=canvas.height;
    for(let y=0;y<h;y++)for(let x=0;x<w;x++){if(x>1&&x<w-2&&y>1&&y<h-2)continue;const sx=Math.max(2,Math.min(w-3,x)),sy=Math.max(2,Math.min(h-3,y));for(let c=0;c<4;c++)data[(y*w+x)*4+c]=copy[(sy*w+sx)*4+c];}
   }
   extendCorners(image.data,canvas.width,canvas.height,entry.sourceCornerRadiusMm);context.putImageData(image,0,0);}
  return {canvas,crop};
 };
 window.BBArtworkGeometry={validate,extendCorners,prepare};
})();
